import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('banners-management-routing', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider.state('cms-bannersManagement', {
      parent: 'arw',
      url: '/cms-banners-management',
      template: '<banners-management></banners-management>',
      redirectTo: 'permissions-denied',
      params: {
        pageTitle: [
          '$ngRedux',
          'gettextCatalog',
          ($ngRedux, gettextCatalog) => {
            $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Home Page Banners')));
          },
        ],
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/banners/banners-management-routing-module.js